import React from 'react';

import { Select } from '@gogame/components';
import { useScreenDispatch } from '@gogame/screens';

import { SET_CHART_BREAKDOWN } from 'scenes/Trackers/Tracker/reducers';

import { useChartIndex, useChartState } from '../hooks';

export const SelectBreakdownMetric = ({ metrics, loading }) => {
  const chartIndex = useChartIndex();
  const chartState = useChartState();
  const dispatch = useScreenDispatch();

  const handleChangeBreakdownMetric = (_e, value) => {
    dispatch({
      type: SET_CHART_BREAKDOWN,
      payload: {
        index: chartIndex,
        value: {
          ...chartState.breakdown,
          breakdownMetric: value,
        },
      },
    });
  };
  return (
    <Select
      width={'184px'}
      options={metrics}
      label={'Metric'}
      groupBy={'groupName'}
      loading={loading}
      autoFocus={!chartState.breakdown.breakdownMetric}
      value={chartState.breakdown.breakdownMetric || ''}
      onChange={handleChangeBreakdownMetric}
      dropdownWidth={274}
      multipleSearch={true}
    />
  );
};
